<div class="date-filter-container g-just-flex align-items-center gap-12" style="padding: 10px 0;">
  <button mat-stroked-button (click)="openFilterDialog()">
    <mat-icon>filter_list</mat-icon>
    Filter by Date
  </button>
  
  @if(activeStart || activeEnd) {
    <mat-chip-set>
      <mat-chip>
        {{ activeStart ? (activeStart | date:'mediumDate') : 'Any' }} - {{ activeEnd ? (activeEnd | date:'mediumDate') : 'Any' }}
        <button matChipRemove (click)="clearFilter()" matTooltip="Clear Filter">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-set>
  }
</div>
